import { createFileRoute } from '@tanstack/react-router';

// 顧客詳細 > 紐づく価値の編集画面。
// URL search は持たない（候補ダイアログ内検索はローカル state で完結）ため
// ここではルート定義のみ。コンポーネントは index.lazy.tsx で遅延ロードする。
export const Route = createFileRoute('/_stacktrace/customers/$customerId/_layout/values/edit/')({});